import { render } from "./DayIndicators.vue?vue&type=template&id=36f2b099"
import script from "./DayIndicators.vue?vue&type=script&lang=js"
export * from "./DayIndicators.vue?vue&type=script&lang=js"

import "./DayIndicators.vue?vue&type=style&index=0&id=36f2b099&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__